var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.dev)?_c('Preloader'):_c('div',[_c('DetailCarousel',{attrs:{"items":_vm.dev.images}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }